import { render, staticRenderFns } from "./WorkDetailType.vue?vue&type=template&id=e944707c&scoped=true"
import script from "./WorkDetailType.vue?vue&type=script&lang=js"
export * from "./WorkDetailType.vue?vue&type=script&lang=js"
import style0 from "./WorkDetailType.vue?vue&type=style&index=0&id=e944707c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e944707c",
  null
  
)

export default component.exports